<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Recall Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div v-if="this.$route.query.id === undefined" class="row">
            <div class="form-group col-3">
                <label for="subject">Customer Complaint</label>
                <app-lookup-field :model="r" :element="ccLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="subject">NCR</label>
                <app-lookup-field :model="r" :element="ncrLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Recall Number</label>
                <input type="text" class="form-control" id="recall-no" v-model="r.recallNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Qty</label>
                <input type="number" class="form-control" id="qty" v-model="r.qty" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Analysis</label>
                <input type="text" class="form-control" id="distributed-internal" v-model="r.analysis" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Recall Process Step</label>
                <input type="text" class="form-control" id="customer" v-model="r.recallProcessStep" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Non Conformance Process Step</label>
                <input type="text" class="form-control" id="brand" v-model="r.nonConformanceProcessStep" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Recall Start Date</label>
                <flat-pickr class="form-control" v-model="r.recallStartDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="subject">Recall Complete Date</label>
                <flat-pickr class="form-control" v-model="r.recallEndDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Claim Cost</label>
                <input type="number" class="form-control" id="pic" v-model="r.claimCost" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Handling Recall Cost</label>
                <input type="number" class="form-control" id="handling-cost" v-model="r.handlingRecallCost" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Non Conformance Handling Cost</label>
                <input type="number" class="form-control" id="pic" v-model="r.nonConformanceHandlingCost" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Other Cost</label>
                <input type="number" class="form-control" id="other-cost" v-model="r.otherCost" disabled>
            </div>
        </div>
        <br /><br />
        <!-- <div v-if="this.r.customerComplaintId" class="row">
            <div class="form-group col-12">
              <label for="comment">Customer Complaint Data</label>
              <app-datatable :type="'view'" :elements="dtElementsCC" :collections="r.customerComplaint"></app-datatable>
            </div>
        </div>
        <br /><br />
        <div v-if="this.r.ncrId" class="row">
            <div class="form-group col-12">
              <label for="comment">NCR Data</label>
              <app-datatable :type="'view'" :elements="dtElementsNCR" :collections="r.ncr"></app-datatable>
            </div>
        </div>
        <div v-if="this.r.customerComplaintId" class="row">
            <br /><br />
            <div class="form-group col-12">
              <label for="comment">Corrective Internal Data</label>
               <app-datatable :type="'view'" :elements="dtElementsInternal" :collections="r.customerComplaintCorrectiveInternal"></app-datatable>
            </div>
        </div> -->
        <!-- <div v-if="this.r.customerComplaintId">Customer Complaint Data</div>
        <app-datatable v-if="this.r.customerComplaintId" :type="'view'" :elements="dtElementsCC" :collections="r.customerComplaint"></app-datatable>
        <br /><br />
        <div v-if="this.r.customerComplaintId">Corrective Internal Data</div>
        <app-datatable v-if="this.r.customerComplaintId" :type="'view'" :elements="dtElementsInternal" :collections="r.customerComplaintCorrectiveInternal"></app-datatable> -->
        <br />
        <div class="row">
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="r.comment" rows="3"></textarea>
            </div>
        </div>
        <button type="button" v-if="this.r.customerComplaintId" class="btn btn-outline-success" @click="previewcparcc">Print CPAR-CC <i class="fas fa-print"></i></button>
        <button type="button" v-if="this.r.customerComplaintId" class="btn btn-outline-success" @click="previewccf">Print CCF <i class="fas fa-print"></i></button>
        <button type="button" v-if="this.r.ncrId" class="btn btn-outline-success" @click="previewcparncr">Print CPAR-NCR <i class="fas fa-print"></i></button>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="approve">Approve <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-info" @click="decline">Decline <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { recallApproval } from '../../models/recall'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          r: {...recallApproval, customerComplaint:[], customerComplaintCorrectiveInternal: []},
          ccLookup: {
                id: 'cc-list',
                title: 'Customer Complaint List',
                type: 'form',
                apiUrl: 'recall-cc-list',
                filter: ['complaintNo'],
                fields: [
                    {
                        placeholder: 'Complaint No',
                        width: 12,
                        column: 'complaintNo'
                    }
                ],
                dtElements: [
                    {
                        title: 'Complaint No',
                        column: 'complaintNo'
                    },
                ],
                affectedField: [
                    {
                        from: 'customerComplaintId',
                        to: 'customerComplaintId'
                    },
                    {
                        from: 'complaintNo',
                        to: 'complaintNo'
                    },
                ]
          },
          ncrLookup: {
                id: 'ncr-list',
                title: 'Customer Complaint List',
                type: 'form',
                apiUrl: 'recall-ncr-list',
                filter: ['complaintNo'],
                fields: [
                    {
                        placeholder: 'Complaint No',
                        width: 12,
                        column: 'complaintNo'
                    }
                ],
                dtElements: [
                    {
                        title: 'Complaint No',
                        column: 'complaintNo'
                    },
                ],
                affectedField: [
                    {
                        from: 'customerComplaintId',
                        to: 'customerComplaintId'
                    },
                    {
                        from: 'complaintNo',
                        to: 'complaintNo'
                    },
                ]
          },
          dtElementsCC: [
            {
                title: 'Complaint No',
                column: 'complaintNo',
                type: 'text',
                width: 8,
            },
            {
                title: 'Customer Name',
                column: 'customerName',
                type: 'text',
                width: 8,
            },
            {
                title: 'ProductName',
                column: 'productName',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsNCR: [
            {
                title: 'NCR No',
                column: 'ncrNo',
                type: 'text',
                width: 8,
            },
            {
                title: 'ProductName',
                column: 'productName',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsInternal: [
              {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'machine'
                    },
                    {
                        title: 'Man',
                        value: 'man'
                    },
                    {
                        title: 'Material',
                        value: 'material'
                    },
                    {
                        title: 'Method',
                        value: 'method'
                    },
                    {
                        title: 'Environment',
                        value: 'environment'
                    }
                ]
              },
              {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 6,
              },
              {
                title: 'Corrective Responder Name',
                column: 'correctiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Corrective Responder Name',
                            width: 5,
                            column: 'correctiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'correctivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'correctiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'correctiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Corrective Responder Email',
                column: 'correctiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Corrective Target Date',
                column: 'correctiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 6,
              },
              {
                title: 'Preventive Responder Name',
                column: 'preventiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberPreventive',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Preventive Responder Name',
                            width: 5,
                            column: 'preventiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'preventivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'preventiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'preventiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Preventive Responder Email',
                column: 'preventiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive Target Date',
                column: 'preventiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const rApi = api('recall')
            this.r = await rApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async approve() {
            const rApi = api('recall-approval')
            if(this.$route.query.id !== undefined) {
                const comment = this.r.comment
                await rApi.update({
                    id: this.$route.query.id,
                    action: 'approve',
                    comment: comment,
                    status: this.$route.query.status,
                }, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async decline() {
            const rApi = api('recall-approval')
            if(this.$route.query.id !== undefined) {
                const comment = this.r.comment
                await rApi.update({
                    id: this.$route.query.id,
                    action: 'decline',
                    comment: comment,
                    status: this.$route.query.status,
                }, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async finishLookup(data) {
            const currentr = this.r
            this.r = {
                ...currentr,
                ...data
            }
            const rApi = api('recall-cc-data')
            const ccData = await rApi.getWithParams(this.r.customerComplaintId)
            this.r.customerComplaint = ccData[0]
            this.r.customerComplaintCorrectiveInternal = ccData[1]
        },
        previewcparcc() {
            if(this.selectedId !== '') {
                let newTab = this.$router.resolve({name: 'cpar-cc', query: {id: this.r.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        previewccf() {
            if(this.selectedId !== '') {
                let newTab = this.$router.resolve({name: 'ccf', query: {id: this.r.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        previewcparncr() {
            if(this.selectedId !== '') {
                let newTab = this.$router.resolve({name: 'cpar-ncr', query: {id: this.r.ncrId}});
                window.open(newTab.href, '_blank');
            }
        },
    }
}
</script>